import store from "../lib/store";

const Collection = () => {
  const moveSliderToActive = (slider: HTMLElement, active: HTMLElement) => {
    const activeX = active.getBoundingClientRect().left;
    const sliderX = slider.getBoundingClientRect().left;

    // align the active one to the 'middle' of the view.
    const scrollLeft =
      activeX -
      sliderX -
      window.innerWidth / 2 +
      active.getBoundingClientRect().width / 2;

    if (scrollLeft < 0) {
      return;
    }
    slider.scrollLeft = scrollLeft;
  };

  const slider = document.querySelector(".plp__categories");

  if (slider) {
    let isDown = false;
    let startX = 0;
    let scrollLeft: number = 0;

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = (e as MouseEvent).pageX - (slider as HTMLElement).offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1;
      slider.scrollLeft = scrollLeft - walk;
    });

    // on load, make sure we have moved the slider scroll to the active category
    const active = document.querySelector(".plp__categories-list a.active");

    if (active) {
      moveSliderToActive(slider, active);
    }
  }

  const nav = document.querySelectorAll(".plp__categories-list a");
  const main = document.querySelector(".plp__main");
  const hero = document.querySelector(".hero-simple");

  const addToCart = (btn: HTMLElement | null) => {
    if (!btn) {
      console.error("No button found");
      return;
    }

    const variantId = btn.getAttribute("data-variant-id");

    if (!variantId) {
      console.error("No variant ID found");
      return;
    }

    const quantity = 1;
    btn.classList.add("loading");
    btn.classList.add("disabled");

    const dataLayer = (window as Window & { dataLayer?: unknown[] }).dataLayer;
    if (dataLayer) {
      dataLayer.push({
        event: "collectionPurchase",
        ecommerce: {
          purchase: {
            products: [
              {
                id: variantId,
              },
            ],
          },
        },
      });
    }

    // Add to shopify cart via fetch
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity,
          },
        ],
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        store.updateLastAdd(Date.now());
        btn.classList.remove("loading");
        btn.classList.remove("disabled");
        const icon = btn.querySelector(".button__icon");

        if (icon) {
          // swap inner html to tick svg
          icon.innerHTML =
            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
        }

        const text = btn.querySelector(".button__el");

        if (text) {
          (text as HTMLElement).innerText = "Added!";
        }

        const cartIcon = document.querySelector("#header-cart-icon-button");

        if (cartIcon) {
          (cartIcon as HTMLElement).click();
        }

        document.dispatchEvent(
          new CustomEvent("product:added", {
            detail: {
              variant: { id: variantId },
              quantity,
            },
          })
        );
      });

    return false;
  };

  const attachEvents = () => {
    const cart = document.querySelectorAll(".add-to-cart");

    cart.forEach((addBtn) => {
      addBtn.addEventListener("click", (e) => {
        e.preventDefault();

        let btn = e.target as HTMLElement;

        if (btn && !btn.classList.contains("add-to-cart")) {
          btn = btn.closest(".add-to-cart") as HTMLElement;
        }

        addToCart(btn);

        return false;
      });
    });
  };

  attachEvents();

  // update page via ajax to make it faster
  nav.forEach((item) => {
    item.addEventListener("click", (e) => {
      if (e.target.classList.contains("active")) {
        return false;
      }

      if (e.target.classList.contains("external")) {
        return;
      }

      // remove the other ones with active
      nav.forEach((item) => {
        item.classList.remove("active");
      });

      e.target.classList.add("active");

      if (slider) {
        moveSliderToActive(slider, e.target);
      }

      e.preventDefault();

      if (main) {
        main.classList.add("loading");
        main.innerHTML = "";
      }

      if (hero) {
        hero.innerHTML = "";
      }

      const url = item.getAttribute("href");
      const xhr = new XMLHttpRequest();

      if (url) {
        xhr.open("GET", url, true);
        xhr.onload = function () {
          if (this.status === 200) {
            const response = this.responseText;
            const parser = new DOMParser();
            const doc = parser.parseFromString(response, "text/html");
            const updateHero = doc.querySelector(".hero-simple");
            const updateMain = doc.querySelector(".plp__main");

            // update the current page title and url
            const title = doc.querySelector("title")?.innerText || "";

            document.title = title;

            window.history.pushState(
              {
                path: url,
              },
              title,
              url
            );

            if (hero && updateHero) {
              hero.innerHTML = updateHero.innerHTML;
            }

            if (main && updateMain) {
              main.innerHTML = updateMain.innerHTML;
            }

            setTimeout(() => {
              if (typeof window.lazy !== "undefined") {
                window.lazy.update().check().handlers(true);
              }

              if (typeof window.layzr !== "undefined") {
                window.layzr.update().check().handlers(true);
              }

              // scroll to the top of main
              const y =
                main.getBoundingClientRect().top +
                window.pageYOffset -
                document.querySelector(".js-header").offsetHeight;

              window.scrollTo({ top: y, behavior: "smooth" });

              main.classList.remove("loading");
            }, 50);

            attachEvents();
          }
        };
        xhr.send();
      }

      return false;
    });
  });
};

export default Collection;
